// Dependencies
import React, { useState } from "react";
import { LinkedIn, Facebook, Instagram } from "@material-ui/icons";
import Logo from "../assets/images/logo.svg";
import {
  Nav,
  Navbar,
  StyledBurger,
  PageLink,
  OuterPageLink,
  LinkContainer,
  LogoLink,
  IconContainer,
} from "../styling/HeaderStyling";

// HEADER ------------------------------------------
export const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Nav>
        <LogoLink to="/">
          <img src={Logo} alt="Logotyp We Exist" />
        </LogoLink>

        <Navbar open={open}>
          <LinkContainer>
            <PageLink to="/vara-tjanster" onClick={() => setOpen(!open)}>
              <li>Våra tjänster</li>
            </PageLink>
            <OuterPageLink
              onClick={() => setOpen(!open)}
              href="https://queens.weexist.se/"
              target="_blank"
            >
              <li>För queens</li>
            </OuterPageLink>
            {/* <PageLink to="/for-foretag" onClick={() => setOpen(!open)}>
              <li>För företag</li>
            </PageLink> */}
            <PageLink to="/faq" onClick={() => setOpen(!open)}>
              <li>FAQ</li>
            </PageLink>
            {/* <PageLink to="/kontakt" onClick={() => setOpen(!open)}>
              <li>Kontakt</li>
            </PageLink> */}
          </LinkContainer>
          <IconContainer>
            <a
              href="https://www.linkedin.com/company/we-exist-recruitment/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <LinkedIn className="icon" />
            </a>
            <a
              href="https://www.instagram.com/weexist_recruitment/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Instagram className="icon" />
            </a>
            <a
              href="https://www.facebook.com/weexistrecruitment/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Facebook className="icon" />
            </a>
          </IconContainer>
        </Navbar>

        <StyledBurger open={open} onClick={() => setOpen(!open)}>
          <div />
          <div />
          <div />
        </StyledBurger>
      </Nav>
    </>
  );
};
